const API_URL = process.env.REACT_APP_API_URL || "http://ec2-18-188-81-200.us-east-2.compute.amazonaws.com/api/";
const buildApiUrl = (endpoint, version = "v1") => {
    return `${API_URL}${version}${endpoint}`
}

export default buildApiUrl;


// WEBPACK FOOTER //
// ./src/modules/api/build-api-url.js